<div class="container-fluid p-0 m-0">
  <div class="col-lg-12 m-0 grid-margin stretch-card p-2">
    <div class="bg-white rounded shadow">
      <div class="title-header"><h5 class="m-0 p-0">Add Hoarding</h5></div>
      <div class="card-body container-body">
        <form [formGroup]="form"  class="form-horizontal ml-3" (ngSubmit)="onSubmit(success)">
          <fieldset>
          
          <div class="row">
              <div class="col-md-7 mp-0">
                  <div class="row m-0 p-0">
                        <div class="col-md mp-0">
                                  <!-- Branch Code-->
                                  <div class="form-group">
                                          <label>Region</label>  
                                          <select #region class="custom-select round" formControlName="region_id" (change)="onRegionChange(region.value,true)">
                                              <option value="">Select Region</option>
                                              <option *ngFor="let data of RegionDataLists" [ngValue]="data.id">{{data.name}}</option>
                                          </select>
                                          <!-- error block -->
                                          <div *ngIf="submitted && f.region_id.errors" class="invalid-feedback">
                                            <div *ngIf="f.region_id.errors.required">Region is required</div>
                                          </div> 
                                  </div>
                        </div>
                        <div class="col-md mp-0">
                                  <!-- Store Incharge-->
                                  <div class="form-group">
                                    <label>Showroom</label>
                                    <select class="custom-select round" formControlName="showroom_id">
                                        <option value="">Select Showroom</option>
                                        <option *ngFor="let data of FilterShowroomLists" [ngValue]="data.id">{{data.name}}</option>
                                    </select>
                                    <!-- error block -->
                                    <div *ngIf="submitted && f.showroom_id.errors" class="invalid-feedback">
                                      <div *ngIf="f.showroom_id.errors.required">Showroom is required</div>
                                    </div> 
                                </div>
                        </div>
                  </div>

                  <div class="row m-0 p-0">
                      <div class="col-md mp-0">
                          <div class="form-group">
                            <label >Hoarding Name:</label>
                            <input (keypress)="omit_special_char($event)"  id="" formControlName="name" type="text" class="form-control input-md"  [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                            <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                              <div *ngIf="f.name.errors.required">Hoarding Name is required</div>
                            </div>
                          </div>                         
                      </div>
                      <div class="col-md mp-0">
                            <!-- Add Area -->
                            <div class="form-group">
                              <label>Area</label>  
                                  <input  (keypress)="omit_special_char($event)"  id="contact" formControlName="area" type="text" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.area.errors }">
                                  <div *ngIf="submitted && f.area.errors" class="invalid-feedback">
                                      <div *ngIf="f.area.errors.required">Area is required</div>
                                  </div> 
                            </div>   
                      </div>
                  </div>  
              
                  <div class="row m-0 p-0">
                    <div class="col-md mp-0">
                              <!-- Asset Type-->
                              <div class="form-group">
                                <label>Asset Type</label>  
                                <select class="custom-select round" formControlName="assettype">
                                    <option value="">Select Asset Type</option>
                                    <option *ngFor="let data of AssetsDataLists" [ngValue]="data.id">{{data.name}}</option>
                                </select>
                                <!-- error block -->
                                <div *ngIf="submitted && f.assettype.errors" class="invalid-feedback">
                                  <div *ngIf="f.assettype.errors.required">Asset Type is required</div>
                                </div> 
                          </div>
                    </div>
                    <div class="col-md mp-0">
                      <div class="form-group">
                        <label>Creative</label>  
                        <select class="custom-select round" formControlName="creative">
                          <option value="">Select Creative</option>
                          <option *ngFor="let data of CreativeDataLists" [ngValue]="data.id">{{data.name}}</option>
                        </select>
                        <!-- error block -->
                        <div *ngIf="submitted && f.creative.errors" class="invalid-feedback">
                          <div *ngIf="f.creative.errors.required">Creative is required</div>
                      </div> 
                    </div>
                    </div>
                  </div> 

                  <div class="row m-0 p-0">
                        <div class="col-md mp-0">
                                  <!-- Add Vendor -->
                                  <div class="form-group">
                                          <label>Asset Size - Width :</label>
                                          <input #width id="contact" formControlName="width" type="number" placeholder="" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.width.errors }" (change)="onWidthChange(width.value)">
                                          <div *ngIf="submitted && f.width.errors" class="invalid-feedback">
                                          <div *ngIf="f.width.errors.required">Width is required</div>
                                          <!--<div *ngIf="f.width.errors.pattern">Enter only number.</div>-->
                                          </div> 
                                  </div>
                        </div>
                        <div class="col-md mp-0">
                                  <!-- Asset Size -->
                                  <div class="form-group">
                                        <label>Asset Size - Height :</label>  
                                        <input #height id="contact" formControlName="height" type="number" placeholder="" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.height.errors  }" (change)="onHeightChange(height.value)">
                                        <div *ngIf="submitted && f.height.errors" class="invalid-feedback">
                                        <div *ngIf="f.height.errors.required">Height is required</div>
                                        <!--<div *ngIf="f.height.errors.pattern">Enter only number.</div>-->
                                        </div> 
                                  </div>
                        </div>
                  </div>  

                  <div class="row m-0 p-0">
                    <div class="col-md mp-0">
                              <!-- Add Vendor -->
                              <div class="form-group">
                                      <label>Asset Size - Sq. Ft. :</label>
                                      <input id="contact" formControlName="squarefeet" type="number" placeholder="Sq. Ft." class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.squarefeet.errors }" readonly="readonly">
                                      <div *ngIf="submitted && f.squarefeet.errors" class="invalid-feedback">
                                      <div *ngIf="f.squarefeet.errors.required">Square Feet is required</div>
                                      </div> 
                              </div>
                    </div>
                    <div class="col-md mp-0">
                              <!-- Asset Size -->
                              <div class="form-group">
                                    <label>Cost per month :</label>  
                                    <input id="contact" formControlName="cost" type="number" placeholder="Cost" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.cost.errors }">
                                    <div *ngIf="submitted && f.cost.errors" class="invalid-feedback">
                                    <div *ngIf="f.cost.errors.required">Cost is required</div>
                                    </div> 
                              </div>
                    </div>
              </div>  

                  <div class="row m-0 p-0">
                    <div class="col-md mp-0">
                                    <!-- Date -->
                                    <div class="form-group  mb-0">
                                      <label>Installation Date</label>                         
                                            <input class="form-control-date" matInput [matDatepicker]="pickerinstallation" placeholder="Installation Date" formControlName="install_date" (dateChange)="installChange($event)"  >
                                            <mat-datepicker-toggle matSuffix [for]="pickerinstallation"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerinstallation></mat-datepicker>
                                          <div *ngIf="submitted && f.install_date.errors" class="invalid-feedback">
                                            <div *ngIf="f.install_date.errors.required">Installation Date is required</div>
                                          </div> 
                                      </div>  
                    </div>
                    <div class="col-md mp-0">
                              <!-- Remarks -->
                              <div class="form-group">
                                <label>Expiry Date</label>  
                                        <input [disabled]="form.controls['install_date'].hasError('required')" class="form-control-date" matInput [matDatepicker]="pickerexpiry" placeholder="Expiry Date" formControlName="expiry_date" [min]="minDate">
                                        <mat-datepicker-toggle matSuffix [for]="pickerexpiry"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerexpiry></mat-datepicker>
                                      <div *ngIf="submitted && f.expiry_date.errors" class="invalid-feedback">
                                        <div *ngIf="f.expiry_date.errors.required">Expiry Date is required</div>
                                      </div> 
                              </div>
                    </div>
                  </div> 

                  <div class="row m-0 p-0">
                        <div class="col-md mp-0">
                                <!-- Remarks -->
                                <div class="form-group">
                                  <label>Particulars</label>  
                                      <textarea class="form-control" rows="4" id="comment" id="contact" formControlName="remarks" type="text" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.remarks.errors }"></textarea>  
                                      <div *ngIf="submitted && f.remarks.errors" class="invalid-feedback">
                                        <div *ngIf="f.remarks.errors.required">Particulars is required</div>
                                      </div> 
                                </div>    
                        </div>
                        <div class="col-md mp-0">
                                  <!-- Add Vendor -->
                                  <div class="form-group">
                                        <label>Vendor</label>  
                                          <select class="custom-select round" formControlName="vendor">
                                            <option value="">Select Vendor</option>
                                            <option *ngFor="let data of VendorDataLists" [ngValue]="data.id">{{data.name}}</option>
                                        </select>
                                        <!-- error block -->
                                        <div *ngIf="submitted && f.vendor.errors" class="invalid-feedback">
                                          <div *ngIf="f.vendor.errors.required">Vendor is required</div>
                                        </div> 
                                  </div>
                                  <!-- <a href="#" class="tag">Add New Vendor</a> -->
                        </div>
                  </div>                
              </div>  

              <div class="col-md-5 mp-0">
                    <div class="row m-0 p-0">
                      <div class="col-md-12 mp-0">
                        <label class="label-header">Hoarding Image:</label>
                        <div class="uploader">
            
                          <input id="file-upload" type="file" name="fileUpload" accept="image/*" (change)="onFileChange($event)"/>
            
                          <label for="file-upload" id="file-drag">
                            <img [src]="imageSrc" *ngIf="imageSrc"  id="file-image">
                            <div id="start" *ngIf="!imageSrc">
                              <i class="fa fa-download" aria-hidden="true"></i>
                              <div class="label-header">Select a file</div>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="form-group" style="margin-bottom:0px;">
                      <label></label>
                      <input style="display:none" type="text" class="form-control" (keydown.enter)="$event.preventDefault()" placeholder="Search Location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search>
                    </div>
                    <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom" #agmMap>
                      <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"
                        (dragEnd)="markerDragEnd($event)"></agm-marker>
                    </agm-map>
                    <div class="row m-0 p-0">
                      <div class="col-md-6 mp-0">
                               
                                <div class="form-group">
                                        <label>Latitude :</label>
                                        <input id="contact" formControlName="latitude" type="text" placeholder="Latitude" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.latitude.errors }" readonly="readonly">
                                        <div *ngIf="submitted && f.width.errors" class="invalid-feedback">
                                        <div *ngIf="f.width.errors.required">Latitude is required</div>
                                        </div> 
                                </div>
                      </div>
                      <div class="col-md-6 mp-0">
                            
                                <div class="form-group">
                                      <label>Longitude :</label>  
                                      <input id="contact" formControlName="longitude" type="text" placeholder="Longitude" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.latitude.errors }" readonly="readonly">
                                      <div *ngIf="submitted && f.height.errors" class="invalid-feedback">
                                      <div *ngIf="f.height.errors.required">Longitude is required</div>
                                      </div> 
                                </div>
                      </div>
                   </div>   -->

                   

                   <div class="row m-0 p-0">
                    <div class="col-md-12 mp-0">
                              <div class="form-group">
                                <label >Address:</label>
                                <!-- <input id="" formControlName="address" type="text" class="form-control input-md" > -->
                                <textarea class="form-control" rows="4" id="comment" id="contact" formControlName="address" type="text" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.address.errors }"></textarea>  

                                <div *ngIf="submitted && f.address.errors" class="invalid-feedback">
                                  <div *ngIf="f.address.errors.required">Address is required</div>
                                </div>
                              </div>
                    </div>

                    </div>
                    <div class="text-center mt-4">
                      <button class="btn btn-success mt-4 mr-3 btn-w">Save</button>
                      <button  class="btn btn-secondary btn-w mt-4" type="reset" (click)="onReset()">Reset</button>
                    </div>
              </div> 
          </div>  
          
          </fieldset>
      </form>
      </div>
    </div>
  </div>
</div>

<ng-template #success let-modal class="mp-0">
  <div class="p-2">
    <div class="modal-header justify-content-center">
      <div class="icon-box mx-auto">
        <i class="fa fa-check fa-5x  text-white" aria-hidden="true"></i>
      </div>
    </div>
    <div class="modal-body text-center">
      <h5>New Hoarding has been added successfully.</h5>
      <button class="btn btn-okay" (click)="modal.dismiss('Cross click')"><span>Ok</span></button>
    </div>
  </div> 
</ng-template>